export enum FileType {
    xlsx = 'xlsx',
    pdf = 'pdf',
    doc = 'doc',
    docx = 'docx'
}
